import { LoginService } from './../login.service';
import { SettingsService } from './../settings.service';
import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { writeFile } from 'xlsx';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent implements OnInit {
  startDate
  endDate
  searchType='deleted'
  deletedAppointments=null
  constructor(public settingsService:SettingsService,public ls:LoginService ,private datePipe: DatePipe){ }

  ngOnInit(): void {
    this.startDate = moment().startOf('day')
    this.endDate = moment().endOf('day')
  }


  onStartDateChange(date: Date) {
    
    console.log('Start date changed:', this.startDate);
   
  }
// when user pick a date to end search
  onEndDateChange(date: Date) {
    console.log('End date changed:',  date);
   
  }

  search(){
    let adjustedStartDate = moment(this.startDate).startOf('day').toISOString();
  let adjustedEndDate = moment(this.endDate).endOf('day').toISOString();

    this.settingsService.search(this.searchType,adjustedStartDate,adjustedEndDate,this.ls.doctor).subscribe({
      next: (data) => {
        this.deletedAppointments=data        
      },
      error: (err) => this.deletedAppointments=[]
    })


  }
  exportExcel() {
    let data = this.deletedAppointments.map((appointment) => {
      const date=this.datePipe.transform(appointment.aptTime, 'dd/MM/yyyy HH:mm')
      return {
        "Appointment": appointment.examName,
        "Date": date,
        "Exam Type": appointment.examType,
        "Patient Name": `${appointment.First} ${appointment.Last}`,
        "Patient ID": appointment.ID,
        "Doctor": appointment.Name
      };
    });
  
    const sheetName = 'Report';
  
    const formattedStartDate = this.startDate.format('DD/MM/YYYY'); 
    const formattedEndDate = this.endDate.format('DD/MM/YYYY');     
    const fileName = `report deleted appointments from ${formattedStartDate} to ${formattedEndDate}.xlsx`;
  
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, fileName);
  }
  

}
